export default "__VITE_ASSET__rGsrs05q__"